import { useState } from "react";
import { Link } from "react-router-dom";

const faqs = [
  {
    q: "吹雪漫画网可以免费在线阅读吗？",
    a: "可以。吹雪漫画网为读者提供免费的在线阅读服务，本站收录的雪景、冬日、雪国、冰雪、冬物语与雪女等题材作品均可免费观看，无需下载客户端。",
  },
  {
    q: "为什么有的作品显示「连载中」？",
    a: "「连载中」表示该作品仍在持续更新，编辑部会根据原作者更新节奏同步最新章节，方便你第一时间追更；「已完结」则表示全部章节均已上架。",
  },
  {
    q: "漫画画质如何？会不会很模糊？",
    a: "本站统一采用高清原图渲染，点开即读。若在移动端遇到加载较慢的情况，建议切换到稳定网络，或稍作等待后刷新即可获得更清晰的阅读体验。",
  },
  {
    q: "在哪里可以查看每日更新？",
    a: "首页「本周更新」板块会汇总最近更新的作品与章节，你也可以通过顶部搜索或分类页按题材查找感兴趣的冬日漫画。",
  },
];

export default function FaqPreview() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
      <div className="mb-9 flex items-end justify-between">
        <div>
          <p className="inline-flex items-center gap-2 text-sm text-accent-500">
            <i className="ri-question-line"></i> 常见问题
          </p>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
            阅读前，你想知道的都在这里
          </h2>
        </div>
        <Link to="/faq" className="hidden items-center gap-1 text-sm text-foreground-600 hover:text-primary-500 sm:inline-flex">
          查看全部 <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
        {faqs.map((f, i) => {
          const isOpen = open === i;
          return (
            <div
              key={f.q}
              className={`rounded-lg border p-5 transition-colors ${
                isOpen ? "border-primary-500/40 bg-background-100" : "border-background-200/60 bg-background-100"
              }`}
            >
              <button
                type="button"
                onClick={() => setOpen(isOpen ? null : i)}
                className="flex w-full items-center justify-between gap-3 text-left"
              >
                <span className="font-heading text-base font-semibold text-foreground-950">{f.q}</span>
                <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-transform ${isOpen ? "rotate-180 bg-primary-500 text-background-950" : "bg-secondary-100 text-foreground-700"}`}>
                  <i className="ri-arrow-down-s-line"></i>
                </span>
              </button>
              {isOpen && <p className="mt-3 text-sm leading-7 text-foreground-600">{f.a}</p>}
            </div>
          );
        })}
      </div>
    </section>
  );
}